import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import DataService from '../../../../services/MisDatosService';
import { useAuthStore as useAuthStoreEroski } from '../../../../store/AuthContext';
import useAPIError from '../../../../hooks/useAPIError';
import IconX from '../../../../Icons/IconX';
import IconChat from '../../../../Icons/IconChat';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

// const TarjetaForm: FC<Props> = (props) => {
const AdicionalModal: FC<Props> = (Props) => {
  const { visible, setVisible } = Props;
  const dataUser = useAuthStoreEroski();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { addError, addErrorBack } = useAPIError();

  const [load, setLoad] = useState<boolean>(false);

  const hide = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    setVisible(false);
    document.body.classList.remove('fix');
  };

  useEffect(() => {
    // if (dataUser.user.token !== '')
    setLoad(true);
  }, [dataUser.user.token]);

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('add-btn').click();
    }
  };
  useEffect(() => {
    const element = document.getElementById('modal-adicional') as HTMLElement;
    if (visible && load) {
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else {
      element.removeEventListener('keydown', saveInfo, false);
    }
  }, [visible, load]);

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <div
                className={`modal modal--large ${visible ? 'is-active' : ''}`}
                id="modal-adicional"
              >
                <div className="modal__background" />
                <div className="modal__card">
                  <header className="modal__card-head u-flex">
                    <div className="modal__card-title">
                      ¿Para que tarjeta adicional necesitas una nueva?
                    </div>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <a
                      onClick={() => hide()}
                      className="modal__card-close modal-cerrar"
                    >
                      <div className="icon icon-medium icon--close">
                        <IconX classCss="" />
                      </div>
                    </a>
                  </header>
                  <section className="modal__card-body">
                    <form method="post">
                      <fieldset>
                        <ul className="u-margin-bottom-medium">
                          <li className="u-margin-bottom">
                            <div className="radio radio-inline">
                              <input
                                type="radio"
                                id="perdida"
                                value="perdida"
                                name="necesitastarjeta"
                                className="form-control"
                              />
                              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                              <label
                                htmlFor="perdida"
                                className="control-label"
                              >
                                Para XXXX.
                              </label>
                            </div>
                          </li>

                          <li className="u-margin-bottom">
                            <div className="radio radio-inline">
                              <input
                                type="radio"
                                value="familia"
                                id="familia"
                                name="necesitastarjeta"
                                className="form-control"
                              />
                              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                              <label
                                htmlFor="familia"
                                className="control-label"
                              >
                                Para XXXX
                              </label>
                            </div>
                          </li>
                        </ul>
                        <div className="bloque-num-caprabo">
                          <h2>Numero de tarjeta</h2>
                          <div className="num-tarjeta">
                            <span className="disable">29</span>
                            <span className="disable">910056860</span>

                            <div className="select-wrapper">
                              <select className="form-control">
                                <option value="1">1</option>
                                <option value="1">2</option>
                                <option value="1">3</option>
                                <option value="1">4</option>
                                <option value="1">5</option>
                                <option value="1">6</option>
                                <option value="1">7</option>
                                <option value="1">8</option>
                                <option value="1">9</option>
                              </select>
                              <div className="icon icon-small">
                                <IconChat />
                              </div>
                            </div>
                            <span className="disable">29</span>
                          </div>
                        </div>
                        <div className="botonera">
                          <button
                            id="add-btn"
                            type="submit"
                            className="btn btn-primary"
                          >
                            Solicitar
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </section>
                </div>
              </div>
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default AdicionalModal;
